var map = {
	"./telaPrata (1).png": 2683,
	"./telaPrata (10).png": 8138,
	"./telaPrata (11).png": 9714,
	"./telaPrata (12).png": 6404,
	"./telaPrata (2).png": 9178,
	"./telaPrata (3).png": 8987,
	"./telaPrata (4).png": 2308,
	"./telaPrata (5).png": 4499,
	"./telaPrata (6).png": 6810,
	"./telaPrata (7).png": 8216,
	"./telaPrata (8).png": 6787,
	"./telaPrata (9).png": 9880
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4454;